import script from "./gender.vue?vue&type=script&setup=true&lang=ts"
export * from "./gender.vue?vue&type=script&setup=true&lang=ts"

import "./gender.vue?vue&type=style&index=0&id=314d3430&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-314d3430"]])

export default __exports__